import { postRequest } from 'utils/httpServices';

class submerchantAPI {
  static createSubmerchantSignup = (queryData = {}, config = {}) => {
    return postRequest(`v2/dashboard/referred/create-submerchant`, queryData, config).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400
      })
    );
  };
}

export default submerchantAPI;
